import { render } from "./Digitize-wizard.vue?vue&type=template&id=e2a7be1c&scoped=true"
import script from "./Digitize-wizard.vue?vue&type=script&lang=js"
export * from "./Digitize-wizard.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=e2a7be1c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a7be1c"]])

export default __exports__